// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { LinkedSystem, LinkedSystemAccLinkingValue } from "../misc/LinkedSystem.js";
import { ContainerControl } from "../elements/ContainerControl.js";
import { QuickTableRactive } from "../elements/QuickTable/QuickTableRactive.js";
import { TerceraLinkControlConstants } from "../UtilsClasses/TerceraLinkControlConstants.js";
import { TerceraWindowBase } from "../screen/TerceraWindowBase.js";
import { PanelLocKeys, PanelNames } from "../UtilsClasses/FactoryConstants.js";
import { BrowserUtils } from "../../Commons/UtilsClasses/BrowserUtils.js";
import { ErrorInformationStorage } from "../../Commons/ErrorInformationStorage.js";
import { Resources } from "../../Commons/properties/Resources.js";
import { ThemeManager } from "../misc/ThemeManager.js";
import { DynProperty } from "../../Commons/DynProperty.js";
import { DataCache } from "../../Commons/DataCache.js";
import { MainWindowManager } from "../UtilsClasses/MainWindowManager.js";
import { PanelItemsFactory } from "./PanelItemsFactory.js";
import { WorkSpaceManager } from "../WorkSpaceManager.js";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.js";
import { SessionSettings } from "../../Commons/SessionSettings.js";

export let ApplicationPanelNew = TerceraWindowBase.extend(
    {
        data: function ()
        {
            return {
                symbolLinkValue: TerceraLinkControlConstants.ColorConstants.NONE,
                accountlLinkValue: TerceraLinkControlConstants.ColorConstants.NONE,
                isAccountLinkShow: false,
                isSymbolLinkShow: false,
                resizable: false,
                showFooter: false,
                top: 0,
                left: 0,
                dockablePanel: true,
                workSpaceId: null,
                showHeader: false,
                withBorderRadius: false,
                canLinkByAccount: true,
                canFilterByAccount: true,
                isHeaderMenuButtonShow: false,
                //canSelect: false,
                loading: false
            };
        },
        quickTableRactive: null,
        Name: 'app',
        topPanelHeight: 0,
        margin: 5,

        menuTagDict: [],        // контекстное меню quickTable
        moreThanOneTTKey: '',
        noOneTTKey: '',
        noSymbolWasFoundTooltip: '',

        AllowSettings: true,
        NeedCalculateRowCount: true,
        headerLocaleKey: '',
        rowCount: 0,
        skipOnSave: false,
        skipSomeProperties: false,
        completed: false,
        forceUpdate: false,
        dockSpawnElementsToRemove: new Array()//remove elements of dock system when panel destroing. fix events leak
    });

ApplicationPanelNew.prototype.getType = function () { return PanelNames.ApplicationPanelNew };

//
// Init table
//
ApplicationPanelNew.prototype.jbInit = function ()
{
    try
    {
        var me = this;

        var panelInfo = PanelItemsFactory.GetPanelItem(me.getType());
        if (panelInfo)
        {
            var myQuickTableRactive = new QuickTableRactive();
            me.addControl(myQuickTableRactive);
            var qt = myQuickTableRactive.quickTable;

            //TODO
            qt.InitializeDirect(new panelInfo());
            this.SetColumnsDefaultDisplayIndex(qt);
            this.SetColumnsColouringMode(qt);
            qt.UpdateSortedColumns();
            me.quickTableRactive = myQuickTableRactive;

            if (me.deferredXmlSettingsTemplate)
            {
                qt.xmlSettingsTemplate = me.deferredXmlSettingsTemplate;
                this.visibleColumnChanged(qt.getVisibleColumn());
                delete me.deferredXmlSettingsTemplate;
            }

            me.layoutTable();

            //
            me.OnResize.Subscribe(function () { me.layoutTable(); }, me);

            qt.OnVisibleColumnChanged.Subscribe(this.visibleColumnChanged, this);
            qt.beforeTableContextMenuShowing = this.preparePopup.bind(this);
        }
        //if (me.callbackProperties)
        //    me.callback(me.callbackProperties);
        me.localize();

        this.populateItemsDirect();
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
    }
};

ApplicationPanelNew.prototype.populateItemsDirect = function ()
{

}

ApplicationPanelNew.prototype.SetColumnsDefaultDisplayIndex = function (table)
{

}

ApplicationPanelNew.prototype.SetColumnsColouringMode = function (table)
{

}

ApplicationPanelNew.prototype.ProcessSetColumnsColouringMode = function (table, arr, type, upCustomColor, downCustomColor)
{
    let up = upCustomColor || ThemeManager.CurrentTheme.TableValueUpForeColor;
    let down = downCustomColor || ThemeManager.CurrentTheme.TableValueDownForeColor;
    for (let i = 0; i < arr.length; i++)
    {
        let column = table.columns[arr[i]];
        column.ColouringMode = type;
        column.ValueUpForeColor = up;
        column.ValueDownForeColor = down;
    }
}

ApplicationPanelNew.prototype.ContentContainerHeight = function ()
{
    var contentContainerH = this.get('height');
    if (!this.get('dockablePanel') && this.get('showHeader'))
        contentContainerH -= 20;//header height;

    if (this.isShowExploreTheAppLink()) {
        contentContainerH -= 25;
    }

    return contentContainerH;
};

ApplicationPanelNew.prototype.ShowTotalsStateChange = function (menuItem)
{
    this.UpdateShowTotalsStateChange(menuItem.checked);
}

ApplicationPanelNew.prototype.UpdateShowTotalsStateChange = function (state)
{
    let qt = this.quickTableRactive.quickTable
    if (!qt) return

    qt.ShowTotals = state
    qt.onResize();
}

ApplicationPanelNew.prototype.UpdateGroupByState = function (InitGroupByColumnIndex)
{
    if (!this.quickTableRactive) return
    let qt = this.quickTableRactive.quickTable

    let menu = qt.groupByContextMenuItems,
        groupByMenuItem = null
    if (!menu) return

    for (let i = 0; i < menu.subitems.length; i++)
    {
        let menuItem = menu.subitems[i]

        if (menuItem.tag.PRIVATE.index == InitGroupByColumnIndex)
        {
            groupByMenuItem = menuItem
            break
        }
    }

    if (groupByMenuItem)
    {
        groupByMenuItem.checked = true
        qt.onGroupByMenuItemClicked(groupByMenuItem);
    }
}

ApplicationPanelNew.prototype.layoutTable = function ()
{
    if (this.quickTableRactive === null)
        return;

    var margin = this.margin;
    var topMargin = this.topPanelHeight + margin;
    var scrWidth = this.get('width');

    var scrHeight = this.ContentContainerHeight();

    this.quickTableRactive.setBounds(
        margin,
        topMargin,
        Math.abs(scrWidth - 2 * margin),
        Math.abs(scrHeight - margin - topMargin));
}

ApplicationPanelNew.prototype.oninit = function ()
{
    TerceraWindowBase.prototype.oninit.apply(this);

    this.observe('symbolLinkValue', function (newVal, oldVal, key)
    {
        this.symbolLink_Out(true);
    });
    this.observe('accountlLinkValue', function (newVal, oldVal, key)
    {
        this.accountLink_Out(true);
    });

    this.observe('isSymbolLinkShow isAccountLinkShow', function (newVal, oldVal, key)
    {
        this.updateLinkVisible();

        if (!newVal && key == 'isAccountLinkShow')
            this.filterByAccountNumber(newVal)
    });

    this.observe('header', function (newVal)
    {
        if (newVal && this.setTitle)
            this.setTitle(newVal);
    });

    if (Resources.isHidden('allowLinkSystem'))
    {
        this.set({
            isAccountLinkShow: false,
            isSymbolLinkShow: false,
        });
    }
};

ApplicationPanelNew.prototype.oncomplete = function ()
{
    var me = this;
    TerceraWindowBase.prototype.oncomplete.apply(me);
    me.jbInit();

    me.layoutTable();
    if (DataCache.AccountsCount === 1)
    {
        me.set({ isAccountLinkShow: false });
    }

    LinkedSystem.accLinkingActive ? me.enableAccountLinking() : me.disableAccountLinking()

    me.setFocus();

    if (this.InitGroupByColumnIndex !== null)
        this.UpdateGroupByState(this.InitGroupByColumnIndex);

    me.completed = true;
};

ApplicationPanelNew.prototype.gotFocus = function ()
{
    TerceraWindowBase.prototype.gotFocus.apply(this);
    if (this.get('dockablePanel'))
        if (this.containerSetFocus)
            this.containerSetFocus(true);
};

ApplicationPanelNew.prototype.lostFocus = function ()
{
    TerceraWindowBase.prototype.lostFocus.apply(this);
    if (this.get('dockablePanel'))
        if (this.containerSetFocus)
            this.containerSetFocus(false)
};

ApplicationPanelNew.prototype.visibleColumnChanged = function (columnIndexesArray)
{
    var msgData = {};
    msgData.columnIndexesArray = columnIndexesArray;
};

ApplicationPanelNew.prototype.clearTable = function ()
{
    let hasQt = this.quickTableRactive && this.quickTableRactive.quickTable;
    if (hasQt)
        this.quickTableRactive.quickTable.ClearAll();
};

ApplicationPanelNew.prototype.preparePopup = function ()
{
    this.updateSymbolInfoMenuItem()
};

//
//
//
ApplicationPanelNew.prototype.populate = function (addPanel)
{
    if (!addPanel && WorkSpaceManager.needRestoreWS)
        this.repopulate();
};

//
//
//
ApplicationPanelNew.prototype.repopulate = function ()
{
    var hasQt = this.quickTableRactive && this.quickTableRactive.quickTable;
    var qt = null;

    if (hasQt)
        qt = this.quickTableRactive.quickTable;

    if (qt)
        this.quickTableRactive.quickTable.ClearAll();


    if (qt)
        this.visibleColumnChanged(this.quickTableRactive.quickTable.getVisibleColumn());

    if (this.Controls && this.Controls.TerceraInstrumentLookup)
        this.Controls.TerceraInstrumentLookup.repopulate(true);
};

//
//
//
ApplicationPanelNew.prototype.setSize = function (w, h)
{
    let isEq = this.get("width") === w && this.get("height") === h;
    this.set({ width: w, height: h });

    this.layoutTable(isEq);
};

//
//
//
ApplicationPanelNew.prototype.themeChange = function ()
{
    if (this.quickTableRactive)
        this.quickTableRactive.themeChange();
};

//
//
//
ApplicationPanelNew.prototype.localize = function ()
{
    TerceraWindowBase.prototype.localize.apply(this);

    if (this.quickTableRactive && this.quickTableRactive.quickTable)
        this.quickTableRactive.quickTable.localize();

    this.updatePanelHeader();
    this.set({
        banText: Resources.getResource('panel.caption.NotAllowedMode'),
        symbolLinkTooltip: Resources.getResource('panel.AccountLink.SymbolLink.ToolTip')

    });

    this.noSymbolWasFoundTooltip = Resources.getResource('panel.menu.symbolWasNotFound');
    this.localizeAccountLinkTooltip()
};

ApplicationPanelNew.prototype.localizeAccountLinkTooltip = function ()
{
    this.set({ accountLinkTooltip: this.tooltipForAccountLink() });
}

//
//
//
ApplicationPanelNew.prototype.dispose = function ()
{
    let toDisp = this.dockSpawnElementsToRemove;
    if (toDisp)
        for (let i = 0; i < toDisp.length; i++)
            toDisp[i].dispose()

    if (WorkSpaceManager.currentWorkspace)
        WorkSpaceManager.currentWorkspace.removePanel(this._guid);
    TerceraWindowBase.prototype.dispose.apply(this);
};

//
//
//
ApplicationPanelNew.prototype.Properties = function ()
{
    var properties = [];

    properties.push(new DynProperty("X_Position", this.get('left'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("Y_Position", this.get('top'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("Width", this.get('width'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("Height", this.get('height'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("Name", this.getType(), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    properties.push(new DynProperty("WSId", this.get('workSpaceId'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));

    if (this.get('isAccountLinkShow'))
        properties.push(new DynProperty("accountlLinkValue", this.get('accountlLinkValue'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
    if (this.get('isSymbolLinkShow'))
        properties.push(new DynProperty("symbolLinkValue", this.get('symbolLinkValue'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));

    if (this.quickTableRactive)
        properties.push(new DynProperty("GroupByColumnIndex", this.quickTableRactive.quickTable.groupByColumnIndex, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));

    return properties;
};

//
//
//
ApplicationPanelNew.prototype.callBack = function (newProperties)
{
    var newX = DynProperty.getPropValue(newProperties, "X_Position");
    var newY = DynProperty.getPropValue(newProperties, "Y_Position");
    var newWidth = DynProperty.getPropValue(newProperties, "Width");
    var newHeight = DynProperty.getPropValue(newProperties, "Height");
    var wsId = DynProperty.getPropValue(newProperties, "WSId");

    if (this.get('isAccountLinkShow'))
    {
        var dpVal = DynProperty.getPropValue(newProperties, "accountlLinkValue");
        if (dpVal !== null)
            this.set({ accountlLinkValue: dpVal });
    }
    if (this.get('isSymbolLinkShow'))
    {
        var dpVal = DynProperty.getPropValue(newProperties, "symbolLinkValue");
        if (dpVal !== null)
            this.set({ symbolLinkValue: dpVal });
    }

    if (newX !== null && newY !== null && newWidth !== null && newHeight !== null)
        this.setBounds(newX, newY, newWidth, newHeight);
    if (wsId !== null)
        this.setWorkSpaceId(wsId);

    this.InitGroupByColumnIndex = DynProperty.getPropValue(newProperties, "GroupByColumnIndex");
};

ApplicationPanelNew.prototype.updateSettings = function ()
{
    this.forceUpdate = true;
};

ApplicationPanelNew.prototype.canAddRowsCallBack = function () { };

ApplicationPanelNew.prototype.TickAsync = function ()
{
    if (this.quickTableRactive/*&& this.quickTableRactive.quickTable.needRedraw*/)
    {
        var qt = this.quickTableRactive.quickTable;

        let visible = this.get("visible");

        if (qt.rowCountChanged)
        {
            this.rowCount = qt.getDataRowsCount();
            qt.rowCountChanged = false;
            this.updatePanelHeader();
        }

        if (!visible)
            return;

        qt.updateRowsCellsValues(this.forceUpdate);
        qt.needRedraw = false;
        qt.Draw();
        this.forceUpdate = false;
    }
};

ApplicationPanelNew.prototype.onMouseDown = function (event, isHeader)
{
    TerceraWindowBase.prototype.onMouseDown.apply(this, [event, isHeader]);
};


ApplicationPanelNew.prototype.symbolLink_Out = function (newSubscriber, account)
{

};
ApplicationPanelNew.prototype.symbolLink_In = function (symbolName)
{

};

ApplicationPanelNew.prototype.accountLink_Out = function (newSubscriber, instrument)
{

};
ApplicationPanelNew.prototype.accountLink_In = function (accId)
{
    this.filterByAccountNumber(accId)
};

ApplicationPanelNew.prototype.updateLinkVisible = function ()
{

};

ApplicationPanelNew.prototype.setWorkSpaceId = function (id)
{
    this.set({ workSpaceId: id });
};

ApplicationPanelNew.prototype.getWorkSpaceId = function ()
{
    return this.get('workSpaceId');
};

ApplicationPanelNew.prototype.updatePanelHeader = function ()
{
    let subItemsCount = this.quickTableRactive ? this.quickTableRactive.quickTable.getSubItemsRowsCount(false) : 0,
        rowNumSt = this.rowCount - subItemsCount        // - (all FIFO sub items) #80010
    if (LinkedSystem.accLinkingActive && this.quickTableRactive && this.get("canLinkByAccount"))
    {
        subItemsCount = this.quickTableRactive.quickTable.getSubItemsRowsCount(true)
        let visibleRowCount = this.quickTableRactive.quickTable.visibleRowCount() - subItemsCount   // - (visible FIFO sub items) #80010
        rowNumSt = visibleRowCount + '/' + rowNumSt
    }
    this.set({ header: Resources.getResource(this.headerLocaleKey) + (this.NeedCalculateRowCount ? ('  (' + rowNumSt + ')') : '') });
};

ApplicationPanelNew.prototype.tooltipForAccountLink = function ()
{
    let tooltip = Resources.getResource('panel.AccountLink.CanFilterToolTip')

    if (!this.get('canFilterByAccount'))
    {
        tooltip = Resources.getResource('panel.AccountLink.ToolTip')
        let acc = this.get('accountItem') || this.get('account')
        if (acc)
            tooltip += ' : ' + acc.FullAccString
        else
            tooltip = Resources.getResource('panel.accounts.AccountLink.ToolTip')   // AssetBalancesPanel
    }

    return tooltip
}

ApplicationPanelNew.prototype.enableAccountLinking = function (accId)
{
    if (this.get('canLinkByAccount'))
    {
        accId = accId || LinkedSystem.getAccount(LinkedSystemAccLinkingValue)
        this.updateAccountLinkVisible(true)

        this.filterByAccountNumber(accId)
    }
};

ApplicationPanelNew.prototype.disableAccountLinking = function ()
{
    if (this.get('canLinkByAccount'))
    {
        this.updateAccountLinkVisible(false)

        if (this.quickTableRactive)
            this.quickTableRactive.quickTable.setAllRowsVisibility(true)
    }
};

ApplicationPanelNew.prototype.filterByAccountNumber = function (accId)
{
    if (this.get('canLinkByAccount') && this.quickTableRactive)
        this.quickTableRactive.quickTable.filterByAccountNumber(accId)
};

ApplicationPanelNew.prototype.updateAccountLinkVisible = function (visible)
{
    if (this.get('canLinkByAccount'))
    {
        this.set('isAccountLinkShow', visible)
        this.updateLinkVisible()
    }
};

ApplicationPanelNew.prototype.getXmlSettingsTemplate = function ()
{
    var xml = {};

    var qtRactive = this.quickTableRactive;
    var qt = qtRactive ? qtRactive.quickTable : null;
    if (qt) xml = qt.xmlSettingsTemplate;

    return xml;
};

ApplicationPanelNew.prototype.setXmlSettingsTemplate = function (value)
{
    var qtRactive = this.quickTableRactive;
    var qt = qtRactive ? qtRactive.quickTable : null;
    if (qt)
    {
        qt.xmlSettingsTemplate = value;
        this.visibleColumnChanged(qt.getVisibleColumn());
    }
    else
        this.deferredXmlSettingsTemplate = value;
};


ApplicationPanelNew.prototype.setSettings = function (json)
{
    this.callBack(DynProperty.deserialize(JSON.parse(json)));
};

ApplicationPanelNew.prototype.getSettings = function ()
{
    return JSON.stringify(DynProperty.serialize(this.Properties()));
};

ApplicationPanelNew.prototype.setVisibleColumns = function (arr)
{
    var qtRactive = this.quickTableRactive;
    var qt = qtRactive ? qtRactive.quickTable : null;
    if (qt)
    {
        qt.setVisibleColumn(arr);
    }
};

ApplicationPanelNew.prototype.workWithToolBar = function ()
{

}

ApplicationPanelNew.prototype.onKeyDown = function (event)
{
    TerceraWindowBase.prototype.onKeyDown.call(this, event);
    var original = event.original;
    if (original.keyCode < 48 || original.keyCode > 90 || original.altKey || original.ctrlKey || original.shiftKey)
        return true;
    var activeCtrl = this.get("activeControl");
    if (activeCtrl)
    {
        var actType = activeCtrl.getType();
        if (ApplicationPanelNew._striplostFocusTypes.indexOf(actType) !== -1)
            return true;
    }
    this._onKeyDownProcess(event);
};
ApplicationPanelNew.prototype._onKeyDownProcess = function (event)
{
    var controls = this.Controls
    if (controls)
    {
        var lookup = controls.TerceraInstrumentLookup;
        if (!lookup)
            if (controls.topPanel)
                controls = controls.topPanel.Controls;
        if (controls)
            lookup = controls.TerceraInstrumentLookup;
        if (!lookup)
            return;

        if (!lookup.get('focused'))
        {
            if (lookup.textBox !== null)
            {
                lookup.textBox.set({ text: "", skipfocus: true })
                lookup.setFocus();
                lookup.onKeyDown(event);
            }
        }
    }
}

ApplicationPanelNew._striplostFocusTypes = ["TerceraAccountLookup", "TerceraNumeric", "TerceraTextBox", "TerceraQuantityNumeric", "TerceraSLTPNumeric", "NAME_ORDERCOMPOSIT_PANEL", "DynPropertyControl", "OEQuantity", "AdvancedChartOrderEntry", "TerceraVisualTradingWidget"];

ApplicationPanelNew.prototype.setVisibility = function (visible)
{
    this.set({ visible: visible });
}

/// <summary>
/// Инструмент выбранный в таблице (первый если их несколько)
/// </summary>
ApplicationPanelNew.prototype.getInstrument = function ()
{
    let qt = this.quickTableRactive ? this.quickTableRactive.quickTable : null
    if (!qt) return null;

    let selectedRowIds = qt.selectedRowIds,
        row = selectedRowIds && selectedRowIds[0] ? qt.rows[selectedRowIds[0]] : null

    return row && row.item ? row.item.GetCurrentInstrument() : null
}

/// <summary>
/// Аккаунт
/// </summary>
ApplicationPanelNew.prototype.getAccount = function ()
{
    return null;
}

ApplicationPanelNew.prototype.openSymbolInfo = function ()
{
    let ins = this.getInstrument()

    if (ins)
        MainWindowManager.MainWindow.ShowSymbolInfo(ins)
}

ApplicationPanelNew.prototype.AddSymbolInfoContextMenuItemIfNeed = function (items, addSeparator)
{
    if (MainWindowManager.Factory.panelAllowed(PanelNames.SymbolInfoPanel))
    {
        if (addSeparator !== false)
            items.push({ separator: true })

        let key = 'panel.watchlist.menu.SymbolInfo'

        items.push({
            locKey: key,
            text: Resources.getResource(key),
            event: this.openSymbolInfo.bind(this),
            enabled: false,
            disabledReason: null,
            tag: ApplicationPanelNew.SYMBOLINFOPANEL
        })
    }
}

ApplicationPanelNew.prototype.AddOpeningPanelsCM = function (items)       
{
    let lokKeys = this.GetOpeningPanelsCMLocKeysSet();
    let lK = lokKeys[ApplicationPanelNew.OPEN_CHART];
    let newItems = []

    if (!Resources.isHidden(lK))
        newItems.push({
            locKey: lK,
            event: this.openPanel.bind(this, PanelNames.ChartPanel),
            enabled: false,
            tag: ApplicationPanelNew.OPEN_CHART
        })

    lK = lokKeys[ApplicationPanelNew.OPEN_MD];
    if (!Resources.isHidden(lK))
        newItems.push({
            locKey: lK,
            event: this.openPanel.bind(this, PanelNames.MarketDepthPanel),
            enabled: false,
            tag: ApplicationPanelNew.OPEN_MD
        })

    lK = lokKeys[ApplicationPanelNew.OPEN_TS];
    if (!Resources.isHidden(lK))
        newItems.push({
            locKey: lK,
            event: this.openPanel.bind(this, PanelNames.TSPanel),
            enabled: false,
            tag: ApplicationPanelNew.OPEN_TS
        })

    lK = lokKeys[ApplicationPanelNew.OPEN_OE];
    if (!Resources.isHidden(lK))
        newItems.push({
            locKey: lK,
            event: this.openPanel.bind(this, PanelNames.AdvancedOrderEntry),
            enabled: false,
            tag: ApplicationPanelNew.OPEN_OE
        })

    if (newItems.length)
    {
        newItems.unshift({ separator: true })
        newItems.push({ separator: true })
    }

    return items.concat(newItems)
}

ApplicationPanelNew.prototype.SetOpeningPanelsCMEnability = function (menuTagDict, enabled)
{
    if (menuTagDict[ApplicationPanelNew.OPEN_CHART])
        menuTagDict[ApplicationPanelNew.OPEN_CHART].enabled = enabled;
    if (menuTagDict[ApplicationPanelNew.OPEN_MD])
        menuTagDict[ApplicationPanelNew.OPEN_MD].enabled = enabled;
    if (menuTagDict[ApplicationPanelNew.OPEN_TS])
        menuTagDict[ApplicationPanelNew.OPEN_TS].enabled = enabled;
    if (menuTagDict[ApplicationPanelNew.OPEN_OE])
        menuTagDict[ApplicationPanelNew.OPEN_OE].enabled = enabled;
}

ApplicationPanelNew.prototype.getSelectedInstrumentID = function ()
{
    return ""
};

ApplicationPanelNew.prototype.GetOpeningPanelsCMLocKeysSet = function ()
{
    return {};
};

ApplicationPanelNew.prototype.openPanel = function (panelName)
{
    var ins = this.getSelectedInstrumentID();
    MainWindowManager.Factory.addPanel(panelName, null, function (panel) { panel.symbolLink_In(ins); });
};

ApplicationPanelNew.OPEN_CHART = 'openChart';
ApplicationPanelNew.OPEN_MD = 'openMD';
ApplicationPanelNew.OPEN_TS = 'openTS';
ApplicationPanelNew.OPEN_OE = 'openOE';

ApplicationPanelNew.SYMBOLINFOPANEL = 'SymbolInfoPanel';

ApplicationPanelNew.prototype.getSelectedItemsNumber = function ()                  
{
    let qt = this.getQuickTable();
    if (!qt) return 0

    let selectedRowIds = qt.selectedRowIds
    if (selectedRowIds && selectedRowIds.length)
        return selectedRowIds.length

    return 0
}

ApplicationPanelNew.prototype.getSelectedDifferentItemsNumber = function ()
{
    let qt = this.getQuickTable();
    if (!qt) return 0

    let selectedRowIds = qt.selectedRowIds
    if (selectedRowIds && selectedRowIds.length)
    {
        let firstItem = this.getInstrument()
        if (!firstItem) return 0

        let firstID = firstItem.GetInteriorID()
        for (let i = 1; i < selectedRowIds.length; i++)     // может быть выбрано несколько ордеров(позиций) одного и того же инструмента
        {
            let row = selectedRowIds[i] ? qt.rows[selectedRowIds[i]] : null,
                ins = row && row.item ? row.item.GetCurrentInstrument() : null

            if (!ins || ins.GetInteriorID() != firstID)     // выбраны разные инструменты 
                return selectedRowIds.length                // пока нам достаточно знать, что выбрано хотя бы 2 разных инструмента
        }

        return 1                                            // нулевой выбранный совпадает с остальными выбранными - это один и тот же инструмент
    }

    return 0
}

ApplicationPanelNew.prototype.getQuickTable = function ()
{
    return this.quickTableRactive ? this.quickTableRactive.quickTable : null
}

ApplicationPanelNew.prototype.updateSymbolInfoMenuItem = function ()
{
    let menuArr = this.menuTagDict;
    let menuItem = menuArr ? menuArr[ApplicationPanelNew.SYMBOLINFOPANEL] : null
    this.updateMenuItem(menuItem)
};

ApplicationPanelNew.prototype.updateMenuItem = function (menuItem)
{
    if (!menuItem)
        return

    let moreThanOneTTKey = this.moreThanOneTTKey,
        noOneTTKey = this.noOneTTKey

    let ins = this.getInstrument(),
        selInsNum = this.getSelectedDifferentItemsNumber(),
        enabled = !!(selInsNum == 1 && ins),
        tooltip = enabled ? '' : Resources.getResource(selInsNum ? moreThanOneTTKey : noOneTTKey)

    if (!ins && this.getSelectedItemsNumber() > 0) // выбранного инструмента нет у нас в Instruments (к примеру строка по скрытому или удаленному инструменту в Orders history)
        tooltip = this.noSymbolWasFoundTooltip

    menuItem.enabled = enabled;
    menuItem.tooltip = tooltip;
    menuItem.style = enabled ? '' : 'js-context-menu-error';
};

ApplicationPanelNew.prototype.CustomPreparation = function ()
{

}

ApplicationPanelNew.prototype.validateProperties = function (properties) // help in migration process: checking if properties for callback are correct and suitable for current version
{
    return true
}

ApplicationPanelNew.prototype.GetWSIdFromProperty = function (properties) // help in migration process: get lost WSid 
{
    return DynProperty.getPropValue(properties, "WSId");
}

ApplicationPanelNew.prototype.RefreshInstrumentDescriptions = function (insArray)
{

}

ApplicationPanelNew.tableToHtml = function (cols, rows, tableTitle)
{
    let tableHTML = '',
        visibleColumnsID = [];
    //can use <table cellpadding="5"> for better readability but there are more list number as result
    tableHTML += '<table width="100%"> <caption><h4>' + tableTitle + '</h4></caption><tr>'
    for (let i = 0; i < cols.length; i++)
    {
        let curColumn = cols[i];
        if (!curColumn.visible || curColumn.hidden)
            continue;
        visibleColumnsID.push(curColumn.PRIVATE.index);
        tableHTML += '<th style="border-collapse:collapse;border:thin solid black;">' + curColumn.headerText + '</th>'
    }
    tableHTML += '</tr>'

    for (let i = 0; i < rows.length; i++)
    {
        let row = rows[i]

        if (row.visible)
        {
            tableHTML += '<tr>'
            for (let j = 0; j < visibleColumnsID.length; j++)
            {
                let col = visibleColumnsID[j]
                tableHTML += '<td style="border:none" align="center">' + row.cells[col].formattedValue + '</td>'
            }
            tableHTML += '</tr>'
        }
    }
    tableHTML += '</table>'

    var DC = DataCache,
        accs = DC.Accounts, accIDs = Object.keys(accs),
        fullName = accs[accIDs[0]].FirstName + ' ' + accs[accIDs[0]].LastName,
        companyName = DC.CompanyName ? DC.CompanyName : ''

    DC.userBaseCurrency = DC.getUserBaseCurrency()

    const lTag = '<tr><td>',
        rTag = ':</td><td align="right">'

    var html = '<h3>' + companyName + '</h3>' +
        '<div style="position:absolute;right:24;width:242;"><table width="100%" style="border:none">' +
        lTag + Resources.getResource("panel.OrderBook.Date") + rTag + DateTimeUtils.formatDate(new Date(), "DD.MM.YYYY HH:mm") +
        lTag + Resources.getResource("panel.OrderBook.Login") + rTag + DC.UserLogin +
        lTag + Resources.getResource("panel.accounts.Owner") + rTag + fullName +
        lTag + Resources.getResource("property.currency") + rTag + DC.userBaseCurrency +
        "</table></div><br><br><br><br><br>" + tableHTML

    return html
}

ApplicationPanelNew.prototype.printTable = function ()
{
    var table = this.quickTableRactive.quickTable,
        cols = table.sortedColumns,
        rows = table.rowsArray,
        title = Resources.getResource(PanelLocKeys[this.getType()]),
        html = ApplicationPanelNew.tableToHtml(cols, rows, title);

    // if (Utils.isChrome)
    // {
    //     var newFrame = document.createElement("frame");
    //     newFrame.id = "print_frame";    
    //     newFrame.name = "print_frame";     
    //     document.body.appendChild(newFrame)

    //     window.frames["print_frame"].document.body.innerHTML = html;  
    //     window.frames["print_frame"].window.print();

    //     document.body.removeChild(newFrame);
    // }
    // else
    // {
    const printWin = window.open('', '', 'width=' + screen.availWidth + ',height=' + screen.availHeight);

    let doc = printWin.document
    doc.open();
    doc.write(html);
    doc.close();

    printWin.print();
    if (BrowserUtils.isChrome)
        printWin.onafterprint = function ()
        {
            printWin.close();
        }
    else
        printWin.close();

}

ApplicationPanelNew.prototype.getCallBackInstrument = function (properties, propName)
{
    let dp = DynProperty.getPropertyByName(properties, propName);
    let symbol = null;
    if (dp && dp.value)
        symbol = DataCache.getInstrumentByName(dp.value);
    if (!symbol)
        symbol = SessionSettings.getFirstTradableInstrument();
    return symbol;
}


// IMPORTANT! 0 - 99 ARE COLUMN INDICES.
// TODO. Ugly.
export let AdditionalRowDataKeys =
{
    INSTRUMENT_KEY: 100,
    ACCOUNT_KEY: 101,
    CELLS_INFO_KEY: 102,
    GROUP_KEY: 103,
    SORT_INDEX_KEY: 104,
    ASSET_ID_KEY: 105,
    FORE_COLOR_KEY: 106,
    BACK_COLOR_KEY: 107,
    ROW_VALUE_KEY: 108,
    SIZE_KEY: 109,
    FROM_WS_LOADING_KEY: 110,
    TR_STOP_SL_ORDER_KEY: 111
};